import type { RouteObject } from 'react-router';
import { practitionerRoutePatterns } from '@/practitioner/constants/routes';

export const practitionerRouteChildren: RouteObject[] = [
  {
    path: practitionerRoutePatterns.dashboard,
    lazy: () => import('@/practitioner/pages/dashboard-page').then((m) => ({ Component: m.DashboardPage })),
  },
  {
    path: practitionerRoutePatterns.home,
    lazy: () => import('@/practitioner/pages/home-page').then((m) => ({ Component: m.HomePage })),
  },
  {
    path: practitionerRoutePatterns.patients,
    lazy: () => import('@/patient/pages/patients-page').then((m) => ({ Component: m.PatientsPage })),
  },
  {
    path: practitionerRoutePatterns.patientDetails,
    lazy: () =>
      import('@/patient/pages/patient-details-page').then((m) => ({
        Component: m.PatientDetailsPage,
      })),
  },
  {
    path: practitionerRoutePatterns.evaluationDetails,
    lazy: () =>
      import('@/evaluation/pages/evaluation-details-page').then((m) => ({
        Component: m.EvaluationDetailsPage,
      })),
  },
  {
    path: practitionerRoutePatterns.articles,
    lazy: () => import('@/media/pages/articles-page').then((m) => ({ Component: m.ArticlesPage })),
  },
  {
    path: practitionerRoutePatterns.articleDetails,
    lazy: () =>
      import('@/media/pages/article-details-page').then((m) => ({
        Component: m.ArticleDetailsPage,
      })),
  },
  {
    path: practitionerRoutePatterns.videos,
    lazy: () => import('@/media/pages/videos-page').then((m) => ({ Component: m.VideosPage })),
  },
  {
    path: practitionerRoutePatterns.videoDetails,
    lazy: () =>
      import('@/media/pages/video-details-page').then((m) => ({
        Component: m.VideoDetailsPage,
      })),
  },
  {
    path: practitionerRoutePatterns.trainings,
    lazy: () => import('@/media/pages/trainings-page').then((m) => ({ Component: m.TrainingsPage })),
  },
  {
    path: practitionerRoutePatterns.trainingDetails,
    lazy: () =>
      import('@/media/pages/training-details-page').then((m) => ({
        Component: m.TrainingDetailsPage,
      })),
  },
  {
    path: practitionerRoutePatterns.notifications,
    lazy: () =>
      import('@/notification/pages/notifications-page').then((m) => ({
        Component: m.NotificationsPage,
      })),
  },
  {
    path: practitionerRoutePatterns.profile,
    lazy: () => import('@/profile/pages/profile-page').then((m) => ({ Component: m.ProfilePage })),
  },
  {
    path: practitionerRoutePatterns.subscription,
    lazy: () => import('@/subscription/pages/liberal-billing-page').then((m) => ({ Component: m.LiberalBillingPage })),
  },
  {
    path: practitionerRoutePatterns.subscriptionSuccess,
    lazy: () =>
      import('@/subscription/pages/checkout-success-page').then((m) => ({ Component: m.CheckoutSuccessPage })),
  },
];
